/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ExtraPaymentMode {
  RECORD_ONLY = 'record_only',
  PAYMENT_LINK = 'payment_link',
  SAVED_CARD_CHARGE = 'saved_card_charge',
  VOUCHER = 'voucher',
  POS_TERMINAL = 'pos_terminal',
}
